import React, { useState } from 'react'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import CustomAddForm from '../../components/version-4/MasterForms/CustomAddForm'
import { useLeadType } from '../../hooks/CompanyConfiguration/useLeadType'
import { ROUTES } from '../../shared/constants'

function LeadType({ leadType }) {
  const [leadTypedata, setLeadTypedata] = useState({
    name: '',
    days: '',
    initial: false,
  })

  React.useEffect(()=>{
    leadType && setLeadTypedata(leadType)
  },[leadType])
  console.log({leadType})
  const { addLeadType, loading, updateLeadType } = useLeadType()
  
  const handleLead = () => {
    if (!leadType) {
      let regex = /^[0-9]+$/
      if (leadTypedata.days.match(regex)) {
        addLeadType({ name: leadTypedata.name, initial: leadTypedata.initial, days: leadTypedata.days })
      } else alert('Only Numeric Values of name accepted')
    } else {
      updateLeadType({ name: leadTypedata.name, leadTypeId: leadType._id, days: leadTypedata.days })
    }
  }
  const formData = [
    { label: 'Name', value: leadTypedata.name, name: 'name' },
    { label: 'Older Upto (Days)', value: leadTypedata.days, name: 'days', conditions: [{ type: 'Number' }] },
  ]
  return (
    <Layout heading="Lead Types" heading2={leadType ? 'Edit' : 'Add'} url1={ROUTES.LEAD_TYPE} form none>
      <HeaderTabLayout
        heading="Lead type"
        content={<CustomAddForm state={leadTypedata} setState={setLeadTypedata} data={formData} />}
        addContent={handleLead}
        redirect={ROUTES.LEAD_TYPE}
        loading={loading}
        state={leadTypedata} setState={setLeadTypedata}
      />
    </Layout>
  )
}

export default LeadType
